import { AspectRatio } from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react'

const RemoteIcon = ({ src, ...props }) => {
  const ref = useRef()
  useEffect(() => {
    const request = new XMLHttpRequest();
    request.open("GET", src);
    request.setRequestHeader("Content-Type", "image/svg+xml");
    request.addEventListener("load", (event) => {
      const response = event.target.responseText;

      const doc = new DOMParser();
      const xml = doc.parseFromString(response, "image/svg+xml");
      const svg = xml.querySelector('svg')
      svg.setAttribute('fill', 'currentColor')
      svg.style.width = '100%'
      svg.style.height = '100%'
      if (ref.current) {
        ref.current.innerHTML = ''
        ref.current.append(svg)
      }
    });
    request.send();
  }, [src])
  return (
    <AspectRatio ratio={1} {...props}>
      <div ref={ref} />
    </AspectRatio>
  )
}

export default RemoteIcon
